import UpdateJob from './UpdateJob';

export default UpdateJob;
